import React from 'react';
import propTypes from 'prop-types';
import accountPropTypes from 'apps/account/propTypes';
import { COLOR_WHITE } from 'common/colors';

export default class VariantImage extends React.Component {
  static propTypes = {
    className: propTypes.string,
    defaultAltText: propTypes.string.isRequired,
    defaultUrl: propTypes.string.isRequired,
    height: propTypes.number,
    selectedVariant: accountPropTypes.ProductVariant,
    variantImages: propTypes.array,
    width: propTypes.number.isRequired,
  };

  selectedImage = () => {
    const {
      selectedVariant,
      defaultUrl,
      defaultAltText,
      variantImages,
    } = this.props;

    if (!selectedVariant || !variantImages) {
      return {
        url: defaultUrl,
        alt: defaultAltText,
      };
    }

    return variantImages.find(image => image.sku === selectedVariant.sku);
  };

  sourceSet = imageURL => {
    const { height, width } = this.props;

    const bg = `bg=rgb:${COLOR_WHITE.replace('#', '')}`;
    const fm = 'fm=jpg';

    // If a height is provided we will also add fit=pad so that our exact
    // dimensions are respected
    const singleHeight = height ? `h=${height}&fit=pad&` : '';
    const doubleHeight = height ? `h=${height * 2}&fit=pad&` : '';
    const tripleHeight = height ? `h=${height * 3}&fit=pad&` : '';

    const single = `${imageURL}?w=${width}&${singleHeight}${bg}&${fm}`;
    const double = `${imageURL}?w=${width * 2}&${doubleHeight}${bg}&${fm} 2x`;
    const triple = `${imageURL}?w=${width * 3}&${tripleHeight}${bg}&${fm} 3x`;

    return `${single}, ${double}, ${triple}`;
  };

  render() {
    const currentImage = this.selectedImage();

    return (
      <img
        className={this.props.className}
        alt={currentImage.alt}
        src={currentImage.url}
        srcSet={this.sourceSet(currentImage.url)}
      />
    );
  }
}

VariantImage.defaultProps = {
  heroImage: false,
};
